import { render, staticRenderFns } from "./Letspay.vue?vue&type=template&id=15d2cbe4&"
import script from "./Letspay.vue?vue&type=script&lang=js&"
export * from "./Letspay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports